export enum RequestState {
  Initial,
  Loading,
  LoadingSucceeded,
  LoadingFailed,
}
